import { useNavigate } from "react-router-dom";

import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  LicenseTypes,
  Operation,
  PageFor,
  empType,
} from "../../../../../utils/Enum.types";
import React, { useContext, useEffect, useState } from "react";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {
  DEFAULT_TIME,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { TableHeaderProps } from "../../../../../utils/types";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import Navbar from "../../../../common/layout/Navbar";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import Modal from "react-modal";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import AddProjectDetails from "./AddProjectDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import MessageModal from "../../../../../customComponents/MessageModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetProjects } from "./queries/queries";
import {
  AtsAcLdgrProjectsEdge,
  AtsAcLdgrProjectsOrderField,
  DeleteProjectResult,
  DeleteProjectVar,
  GetProjectsResult,
  GetProjectsVar,
} from "./queries/types";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import {
  CustomModal,
  getModifiedScrollHeight,
  toInputStandardDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { payloadTypes } from "../../../../../context/reducer";
import SuppliersAutocomplete from "../../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { DeleteProject } from "./queries/mutations";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import useLabels from "../../../../../customHooks/useLabels";
import Close from "../../../../../images/Close.svg";
import ViewParticularProjectDetails from "../../DashBoardMapsView/dashboardcomponents/view/ViewParticularProjectDetails";
import { LdgrQueryType } from "../supplier/queries/types";
import { TableType } from "../../../customer/companies/queries/types";
export interface ModalType {
  operation: Operation;
  id: number;
  flag: boolean;
}
interface Props {
  pageType: PageFor;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProjectDetails = ({ pageType, setModalFlag }: Props) => {
  const { Projects } = useAssetTableJson();

  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const { customer_id } = useUrlParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [employees, setEmployees] = useState<AtsAcLdgrProjectsEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const [operation, setOperation] = useState<Operation>(Operation.CREATE);
  const [searchData, setSearchData] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const { user_details } = useLoggedInUserDetails();
  const { ledgerLabel } = useLabels();

  const [viewParticularProjectDetails, setViewParticularProjectDetails] =
    useState(false);

  const [getProjects, { data, loading, fetchMore }] = useLazyQuery<
    GetProjectsResult,
    GetProjectsVar
  >(GetProjects);

  const [deleteProject, { loading: deleteLoading }] = useMutation<
    DeleteProjectResult,
    DeleteProjectVar
  >(DeleteProject, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = Projects.List.filter(
    (header) =>
      (pageType === PageFor.MODAL && header.field !== "actions") ||
      pageType === PageFor.GENERAL
  ).map((header) => ({
    headerName: header.headerName,
    cellClassName: header.cellClassName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    renderCell: (params) => {
      if (
        state.empSubType === empType.SYS_ADMIN ||
        state.empSubType === empType.PMU
      ) {
        if (params.field === "actions") {
          return (
            <>
              <img
                src={Edit}
                alt="/"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_PROJECT_ID,
                    payload: {
                      projectId: params.row.projectId,
                    },
                  });
                  setOperation(Operation.UPDATE);
                  setAddModal(true);
                }}
              />
              <img
                src={Delete}
                alt="/"
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_PROJECT_ID,
                    payload: {
                      projectId: params.row.projectId,
                    },
                  });
                  setDeleteModal(!deleteModal);
                }}
              />
            </>
          );
        }
      } else return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const HandleDelete = async () => {
    try {
      if (customer_id) {
        setDeleteModal(!deleteModal);
        deleteProject({
          variables: {
            user_details,
            customerID: customer_id,
            projectID: state.projectId,
          },
          refetchQueries: [
            {
              query: GetProjects,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
                after: null,
                first: ROWS_PER_PAGE,
                name: searchData,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsAcLdgrProjectsOrderField.CREATED_AT,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteProject) {
            setMessage({
              flag: true,
              message: "Delete Project successfully",
              operation: Operation.DELETE,
            });
            dispatch({
              type: payloadTypes.SET_PROJECT_ID,
              payload: {
                projectId: 0,
              },
            });
          }
        });
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetProjects.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = employees.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setEmployees(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            projectId: node.id,
            name: node.name,
            vendor: node.supplierName.desc,
            startDate:
              node.startDate &&
              toStandardDate(node.startDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.startDate)
                : "-",

            endDate:
              node.endDate &&
              toStandardDate(node.endDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.endDate)
                : "-",
            contractValue: node.contractValue,
            goLiveDate:
              node.goLiveDate &&
              toStandardDate(node.goLiveDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.goLiveDate)
                : "-",
          }))
        );
      } else {
        setEmployees(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            projectId: node.id,
            name: node.name,
            vendor: node.supplierName.desc,
            startDate:
              node.startDate &&
              toStandardDate(node.startDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.startDate)
                : "-",
            endDate:
              node.endDate &&
              toStandardDate(node.endDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.endDate)
                : "-",
            contractValue: node.contractValue,
            goLiveDate:
              node.goLiveDate &&
              toStandardDate(node.goLiveDate) !== toStandardDate(DEFAULT_TIME)
                ? toStandardDate(node.goLiveDate)
                : "-",
          }))
        );
      }
      setEndCursor(data.GetProjects.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetProjects.edges;
              const pageInfo = fetchMoreResult.GetProjects.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetProjects.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetProjects: {
                  edges: [...employees, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetProjects.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id) {
          getProjects({
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              after: null,
              first: ROWS_PER_PAGE,
              name: searchData,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrProjectsOrderField.CREATED_AT,
              },
            },
          });
        }
      } catch (err) {
        setMessage({
          flag: true,
          message: (err as Error).message,
          operation: Operation.NONE,
        });
      }
    };
    fetchData();
  }, [customer_id, getProjects, user_details.id, searchData]);

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      setAddModal(true);
      setOperation(Operation.CREATE);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.PROJECTS_LIST);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.PROJECTS_LIST,
      JSON.stringify(newModel)
    );
  };

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar
          NavType={
            state.empSubType === empType.PMU ||
            state.empSubType === empType.VENDOR_MANAGER
              ? LicenseTypes.DASHBOARD
              : LicenseTypes.CUSTOMER_USERS
          }
        />
      )}

      <div className="projects-list__title">
        <Title>Project Details</Title>
        {pageType === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <div
        className={`projects-list${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        <div className="row g-0 projects-list__filters">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search ..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchData(e.target.value)
              }
            />
          </div>
          <div className="col-2">
            <SuppliersAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  setSupplierId(newValue.value);
                } else {
                  setSupplierId(0);
                }
              }}
              onKeyDown={() => {}}
              value={state.supplierId}
              label={`${ledgerLabel}`}
              input={{
                itemID: 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: undefined,
              }}
            />
          </div>
          {pageType === PageFor.GENERAL &&
            (state.empSubType === empType.SYS_ADMIN ||
              state.empSubType === empType.PMU) && (
              <div className="col flex-end">
                <Button
                  mode="addnew"
                  autoFocus
                  onClick={() => {
                    setAddModal(true);
                    setOperation(Operation.CREATE);
                  }}
                />
              </div>
            )}
        </div>
        <div className="projects-list__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
            onCellClick={(params) => {
              if (params.field === "name") {
                dispatch({
                  type: payloadTypes.SET_PROJECT_ID,
                  payload: {
                    projectId: params.row.projectId,
                  },
                });
                setOperation(Operation.VIEW);
                setAddModal(true);
              }
            }}
          />
        </div>
        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate(-1)} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <Modal isOpen={addModal} style={AddModalStyles} ariaHideApp={false}>
        <AddProjectDetails setModalFlag={setAddModal} operation={operation} />
      </Modal>

      <LoadingModal flag={(!searchData && loading)} />
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <CustomModal
        style={AddModalStyles}
        isOpen={viewParticularProjectDetails}
        onRequestClose={() =>
          setViewParticularProjectDetails(!viewParticularProjectDetails)
        }
        contentComponent={
          <ViewParticularProjectDetails
            setModalFlag={setViewParticularProjectDetails}
            projectId={state.projectId}
          />
        }
      />
    </>
  );
};

export default ProjectDetails;
